/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholders_Inputnumber1Inputs */

const en_placeholders_inputnumber1 = /** @type {(inputs: Placeholders_Inputnumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a number`)
};

/**
* | output |
* | --- |
* | "Enter a number" |
*
* @param {Placeholders_Inputnumber1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const placeholders_inputnumber1 = /** @type {((inputs?: Placeholders_Inputnumber1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholders_Inputnumber1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_placeholders_inputnumber1(inputs)
});
export { placeholders_inputnumber1 as "placeholders_inputNumber" }